import { render } from "./ProjectsCarousel.vue?vue&type=template&id=d32e59d4&scoped=true"
import script from "./ProjectsCarousel.vue?vue&type=script&lang=js"
export * from "./ProjectsCarousel.vue?vue&type=script&lang=js"

import "./ProjectsCarousel.vue?vue&type=style&index=0&id=d32e59d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d32e59d4"]])

export default __exports__